import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrl, buildAuthHeadersForFetch } from "./RestService";
import IUserModel from "../models/IUserModel";
import ISupplierModel from "../models/ISupplierModel";
import IVendorModel from "../models/IVendorModel";
import IOrder from "../models/IOrder";
import IRelatedOrder from "@models/IRelatedOrder";

interface OrderApiResponse {
    order: IOrder;
    relatedOrders: IRelatedOrder[];
}

/**
 * Get a single order via REST API
 * Uses the same endpoint as socket getOrder but via HTTP
 */
const getOrderRestAPI = async (
    orderGuid: string,
    userModel: IUserModel,
    supplierModel: ISupplierModel,
    vendorModel?: IVendorModel
): Promise<OrderApiResponse> => {
    const url = buildRestUrl({
        endpoint: RestEndpointsEnum.GetOrder,
        params: { orderGuid },
    });

    const headers = buildAuthHeadersForFetch({
        userModel,
        supplierModel,
        vendorModel,
    });

    const response = await fetch(url, {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch order: ${response.statusText}`);
    }

    return response.json();
};

const OrderService = {
    getOrderRestAPI,
};

export default OrderService;
